function collectComponents(components) {
  var output = {};
  components.forEach(function (component) {
    if (component.id == null) {
      throw new Error('Component ID must be specified');
    }
    output[component.id] = component;
  });
  return output;
}

export { collectComponents };
//# sourceMappingURL=collectComponents.js.map
